import React from "react";
import { Label } from "reactstrap";
import { Container, Form, Row, Col } from "react-bootstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";

const SelectCriteriaForm = (props) => {
  const {
    status,
    selectedStatus,
    onStatusChange,
    requestTypeList,
    selectedReqType,
    onRequestTypeChange,
    months,
    selectedMonth,
    onMonthChange,
    years,
    selectedYear,
    onYearChange,
    supervisorsEmpList,
    selectedSupEmpList,
    onSupEmpChange,
  } = props;
  return (
    <Container fluid className="p-0 my-4">
      <Form>
        <Label className="select-criteria-form-title">Select Criteria</Label>
        <Row className="container-row-one">
          <Col lg={4}>
            <Form.Group className="d-flex align-items-center m-0">
              <Form.Label className="label mb-0 mr-5">Status</Form.Label>
              <CustomReactSelect
                className="dropDown ml-0"
                options={status}
                value={selectedStatus}
                onChange={(value) => onStatusChange(value)}
              />
            </Form.Group>
          </Col>

          <Col lg={4}>
            <Form.Group className="d-flex align-items-center m-0">
              <Form.Label className="label mb-0 mr-5">Type</Form.Label>
              <CustomReactSelect
                className="dropDown ml-0"
                options={requestTypeList}
                value={selectedReqType}
                onChange={(value) => onRequestTypeChange(value)}
              />
            </Form.Group>
          </Col>
          <Col lg={4}>
            <Form.Group className="d-flex align-items-center m-0">
              <Form.Label className="label mb-0 mr-5">Employee</Form.Label>
              <CustomReactSelect
                className="dropDown ml-0"
                options={supervisorsEmpList}
                value={selectedSupEmpList}
                onChange={(value) => onSupEmpChange(value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="container-row-two">
          <Col lg={12}>
            <Row>
              <Col lg={4}>
                <Form.Group className="d-flex align-items-center m-0">
                  <Form.Label className="label mb-0 mr-5">Month</Form.Label>
                  <CustomReactSelect
                    className="dropDown ml-0"
                    options={months}
                    value={selectedMonth}
                    onChange={(value) => onMonthChange(value)}
                  />
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group className="d-flex align-items-center m-0">
                  <Form.Label className="label mb-0 mr-5">Year</Form.Label>
                  <CustomReactSelect
                    className="dropDown ml-0"
                    options={years}
                    value={selectedYear}
                    onChange={(value) => onYearChange(value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default SelectCriteriaForm;
